import { ADD_LANGUAGE, ADD_MARKETPLACE, ADD_TOLGEE_STATIC_DATA } from './actionTypes';
export const addLanguage = (language) => {
    return {
        type: ADD_LANGUAGE,
        payload: {
            language,
        },
    };
};
export const setMarketplace = (marketplace) => {
    return {
        type: ADD_MARKETPLACE,
        payload: {
            marketplace,
        },
    };
};
export const addTolggeStaticData = (ssrStaticData) => {
    return {
        type: ADD_TOLGEE_STATIC_DATA,
        payload: {
            ssrStaticData,
        },
    };
};
